import React from 'react'

import { IconButton, Tooltip } from '@chakra-ui/react'
import { DownloadIcon } from 'lucide-react'

import { ExportLoading } from '../../../ui'
import { useTopicsContext } from '../ContextProvider/TopicsContext'

const ExportTopicsButton = () => {
  const { handleExportTopics, isExporting } = useTopicsContext()
  return (
    <>
      <Tooltip label='Export topics'>
        <IconButton icon={<DownloadIcon />} onClick={handleExportTopics} />
      </Tooltip>
      <ExportLoading isLoading={isExporting} />
    </>
  )
}

export default ExportTopicsButton
